/**
 * Airports an out-of-home campaign can run in (UAT UI-020). PURE.
 *
 * The visit data names each airport with its code in brackets ("George Bush
 * Intercontinental Airport (IAH)", category "International Airport"), so an
 * airport is counted by its code; this list only lets the form and DANI
 * recognise a code or a name and say it back. A code not listed here is still
 * counted when the visit data has it.
 */

export const US_AIRPORTS: Record<string, string> = {
    ATL: 'Atlanta Hartsfield-Jackson',
    AUS: 'Austin-Bergstrom',
    BNA: 'Nashville',
    BOS: 'Boston Logan',
    BWI: 'Baltimore/Washington',
    CLT: 'Charlotte Douglas',
    DCA: 'Washington Reagan National',
    DEN: 'Denver',
    DFW: 'Dallas/Fort Worth',
    DTW: 'Detroit Metro',
    EWR: 'Newark Liberty',
    FLL: 'Fort Lauderdale',
    HNL: 'Honolulu',
    HOU: 'Houston Hobby',
    IAD: 'Washington Dulles',
    IAH: 'Houston Bush Intercontinental',
    JFK: 'New York JFK',
    LAS: 'Las Vegas Harry Reid',
    LAX: 'Los Angeles',
    LGA: 'New York LaGuardia',
    MCO: 'Orlando',
    MDW: 'Chicago Midway',
    MIA: 'Miami',
    MSP: 'Minneapolis-St Paul',
    MSY: 'New Orleans',
    OAK: 'Oakland',
    ORD: "Chicago O'Hare",
    PDX: 'Portland',
    PHL: 'Philadelphia',
    PHX: 'Phoenix Sky Harbor',
    RDU: 'Raleigh-Durham',
    SAN: 'San Diego',
    SAT: 'San Antonio',
    SEA: 'Seattle-Tacoma',
    SFO: 'San Francisco',
    SJC: 'San Jose',
    SLC: 'Salt Lake City',
    STL: 'St. Louis Lambert',
    TPA: 'Tampa',
};

/** "BOS (Boston Logan)", or the code alone when it is not on the list. */
export const airportLabel = (code: string) =>
    US_AIRPORTS[code] ? `${code} (${US_AIRPORTS[code]})` : code;

/** Three-letter codes typed or pasted ("IAH, bos dfw"), each once, uppercased. */
export function airportCodesIn(text: string): string[] {
    return [...new Set((text.match(/\b[A-Za-z]{3}\b/g) ?? []).map((c) => c.toUpperCase()))];
}

/**
 * The airports a brief or request names, when it is about airports: listed
 * codes written in capitals ("IAH, BOS and DFW"). Lower-case words are never
 * read as codes, so "the" or "and" cannot become an airport.
 */
export function airportsNamedIn(text: string): string[] {
    if (!/\bairports?\b/i.test(text)) return [];
    return [...new Set(text.match(/\b[A-Z]{3}\b/g) ?? [])].filter((c) => c in US_AIRPORTS);
}
